import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvantorDialogsService } from '@shared/dialogs/avantor-dialogs-api';
import { debounceTime, filter, fromEvent, share, startWith, Subject, switchMap, switchMapTo, takeUntil } from 'rxjs';
import { HEADER_DATA } from '../../header-data.token';
import { MaterialsModule } from '@shared/materials.module';

@Component({
  selector: 'app-enterprise-popup',
  templateUrl: './enterprise-popup.html',
  styleUrls: ['./enterprise-popup.scss'],
  standalone: true,
  imports: [CommonModule, MaterialsModule],
})
export class EnterprisePopupComponent implements OnInit {

  @Output() closePanel = new EventEmitter<void>();
  @ViewChild('dialog', { static: true }) dialog!: ElementRef;
  isOpened = true;
  destroy$ = new Subject<any>();

  constructor(
    @Inject(HEADER_DATA) private data: any,
    private avantorDialogs: AvantorDialogsService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const CdkOverlayOriginEl = this.data;

    document.addEventListener('mousemove', event => {
      let isOutside = this.isMovedOutside(CdkOverlayOriginEl, this.dialog, event);
      if (isOutside) {
        this.close();
      }

    });

  }

  ngOnDestroy(): void {

  }

  private isMovedOutside(CdkOverlayOriginEl: any, dialog: any, event: any): boolean {
    return !(CdkOverlayOriginEl.contains(event['target']) || dialog.nativeElement.contains(event['target']));
  }

  openEnterpriseDialog() {
    this.avantorDialogs.openEnterpriseDialog();
  }

  close() {
    this.closePanel.emit();

  }

}
